<script>
import options from './FormInputCprField.options'
export default options
</script>

<template>
  <div
    class="Form__Element FormTextbox"
    :class="{ ValidationRequired: isRequired }"
  >
    <label :for="fieldName" class="Form__Element__Caption">
      {{ label }}

      <template v-if="tooltipText">
        <TooltipComponent :tooltipText="tooltipText" />
      </template>
    </label>

    <input
      class="FormTextbox__Input"
      v-model="localValue"
      :autocomplete="autocomplete"
      :class="{ 'validation-error': isValidationError }"
      :id="fieldName"
      :type="type"
      :aria-describedby="`${fieldName}__desc`"
      :placeholder="placeholder"
      maxlength="11"
      :readonly="readOnly"
      :disabled="readOnly"
      :required="isRequired ? true : false"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="formLink"
    />

    <p class="kb-form__input-helptext" v-if="helpMessageLabel">
      {{ helpMessageLabel }}
    </p>
    <p
      class="kb-forms Form__Element__ValidationError"
      v-if="inputHasValidationErrors && isValidationError"
    >
      {{ errorMessageLabel }}
    </p>
  </div>
</template>
